import React, { useEffect, useState , useContext} from "react";
import { Link} from "react-router-dom";
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Spinner } from "react-bootstrap";
import $ from 'jquery';
import { useParams, useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import UrlHouse from "../../utils/UrlHouse";
import DefaultProfile from '../../asset/default_profile.png';
import VerifiedBadge from '../../asset/verified_badge.png';
import { AppContext } from "../../utils/AppContext";
import Logo from '../../asset/logo_long_transparent_cropped.png';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import {Helmet} from "react-helmet";

const Ads = () => {
    const navigate = useNavigate();
    const appContext = useContext(AppContext);

    const [adList, setAdList] = useState([])

    const desktopStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px",
        },

        createAdButton: {
            textDecoration: "none"
        }
    }

    const mobileStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px",
        },
    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles

    const [linkPreview, setLinkPreview] = useState({
        title: "Woilo - Photo, Video, Chat, NFTs",
        description: "Woilo - Photo, Video, Chat, NFTs",
        url: "",
        imageUrl: ""
    })

    useEffect(() => {
        init();
      }, [])

    const init = () => {
        $.ajax({
            type: "POST",
            url: UrlHouse.DASHBOARD_ADS_INIT,
            data: JSON.stringify({
                email: localStorage.getItem("email"), password: localStorage.getItem("password")
            }),
            dataType: "json",
            success: function (response) {
                if(response.result === 1){
                    let tempArr = [];
                    response.ad_list.forEach(adData => {
                        let tmp = {
                            adId: adData.ad_id,
                            adName: adData.ad_name,
                            adType: adData.ad_type,
                            adStatus: adData.ad_status,
                            adStartDate: adData.ad_start_date,
                            adEndDate: adData.ad_end_date,
                            adBudget: adData.ad_budget
                        }
                        tempArr.push(tmp);
                    });
                    setAdList(tempArr);
                }else{
                    navigate('/login');
                }
            },
            error: function(e){
                navigate('/login');
            }
        });
    }

    function getAdsItem(item) { 
        let adType = "Iklan Foto";
        if(item.adType === 102){
            adType = "Iklan Video";
        }else if(item.adType === 103){
            adType = "Iklan Karosel";
        }
        let adStatus = "Menunggu Pembayaran";
        if(item.adStatus === 1){
            adStatus = "Sedang ditinjau Tim WoiloAds";
        }else if(item.adStatus === 2){
            adStatus = "Sedang Berjalan";
        }else if(item.adStatus === 3){
            adStatus = "Sudah Selesai";
        }else if(item.adStatus === 4){
            adStatus = "Iklan ditolak";
        }
        return (
            <Link style={{
                textDecoration: "none",
                display: "flex",
                marginTop: "10px",
                paddingLeft: "10px",
                paddingRight: "10px",
                border: "1px solid "+appContext.colors.primaryGrey,
                borderRadius: "10px"}} 
                
                to={"/dashboard/ads/"+item.adId}>
                <div key={item.adId}  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                    color: appContext.colors.primaryBlack,
                    }}>
                    <h4 style={{fontWeight: "400", marginBottom: "0px",}}>{item.adName}</h4>
                    <label>{adType} • {adStatus}</label>
                </div>
            </Link>
        );
    }

    return(
        <>
            <div style={styles.outerContainerStyle}>
                <Helmet>
                    <title>{linkPreview.title}</title>

                    <meta property="og:title" content={linkPreview.title} />
                    <meta property="og:description" content={linkPreview.description} />
                    <meta property="og:image" content={linkPreview.imageUrl} />
                    <meta property="og:url" content={linkPreview.url} />
                    <meta property="og:type" content="website"/>

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:domain" content="woilo.com" />
                    <meta property="twitter:url" content={linkPreview.url} />
                    <meta name="twitter:title" content={linkPreview.title} />
                    <meta name="twitter:description" content={linkPreview.description} />
                    <meta name="twitter:image" content={linkPreview.imageUrl} />
                </Helmet>
                {
                    <div style={styles.mainContainerStyle}>

                        <h1>Iklan Saya</h1>
                        <hr></hr>
                        <Form>
                            <Form.Group as={Row} className="mb-3">
                                <Col sm={{ span: 12}} style={{display: "flex"}}>
                                    <Button onClick={() => {navigate("/dashboard/ads/create")}} style={styles.sendButtonStyle}>Buat Iklan Baru</Button>
                                </Col>
                            </Form.Group>
                        </Form>
                        <div>
                            {adList.length > 0 && adList.map((item) => getAdsItem(item))}
                        </div>
                    </div>
                    
                }
            </div>
        </>
    )
}

export default Ads;